import axios from "axios";
import { getDomainSite, removeDomainSite } from "./site";
import { log2 } from "./log2";
import { CONFIG } from "./config";
import { getTempData } from "./persistenceStorage";
import { getChannelId } from "./channel";
import { getVisitorToken } from "./visitorToken";

removeDomainSite();
const log = log2("request.js");
// let apiAddress =
//     !CONFIG.isProd && CONFIG.isMobile ? "http://mobile-tablet-local.supsis.live/api/" : process.env.TABLET_URL;
let apiAddress = process.env.TABLET_URL;
let apiAddressCdn =
    CONFIG.isProd && window.location.hostname.includes("visitor.supsis.live") && !window.location.hostname.includes("betavisitor.supsis.live")
        ? "https://apicdn.supsis.live/api/"
        : apiAddress;

// CDN'den servis edilecek path'ler
const CDN_PATHS = ["public/settings/get-all", "sites/search/", "public/loginForms/get-all", "public/subjects/get-all"];

// Path'in CDN'den servis edilip edilmeyeceğini kontrol eder
const shouldUseCdn = (url) => {
    log.debug("shouldUseCdn config", {
        CONFIG,
    });
    return CDN_PATHS.some((path) => url.startsWith(path) || url.includes(path));
};

// create an axios instance
const service = axios.create({
    baseURL: apiAddress,
    timeout: 20000, // request timeout
});

// request interceptor
service.interceptors.request.use(
    (config) => {
        log("getDomainSite", getDomainSite());
        if (getDomainSite()) {
            var site = JSON.parse(getDomainSite());
            log("site", site);
            config.headers["site-id"] = site._id;
        }
        const sessionId = getTempData("sessionId");
        if (sessionId) config.headers["session-id"] = sessionId;
        //visitor'a özel endpoint'lerde kimlik doğrulaması için gizli token
        const visitorToken = getVisitorToken();
        if (visitorToken) config.headers["visitor-token"] = visitorToken;

        // ek web chat kanalinda bilgi bankasi ayarlari kanala gore gelir
        if (getChannelId() && /^\/?helpcenter(\/|\?|$)/.test(config.url || "")) {
            config.params = Object.assign({}, config.params, { channel: getChannelId() });
        }

        // CDN path kontrolü
        if (shouldUseCdn(config.url)) {
            config.baseURL = apiAddressCdn;
        }

        return config;
    },
    (error) => {
        Promise.reject(error);
    }
);

export default service;



// WEBPACK FOOTER //
// ./src/utils/request.js